/**
 * TutorialProgressBar - Thin horizontal progress bar under TopBar
 * Shows tutorial completion percentage
 */

interface TutorialProgressBarProps {
  currentStep: number;
  totalSteps: number;
  isActive: boolean;
  isCompleted: boolean;
}

export const TutorialProgressBar = ({
  currentStep,
  totalSteps,
  isActive,
  isCompleted,
}: TutorialProgressBarProps) => {
  if (!isActive || isCompleted) return null;

  const progress = ((currentStep + 1) / totalSteps) * 100;

  return (
    // CORE-BL: the bar carries its own value. A progress indicator whose only
    // expression is a CSS width says nothing to a screen reader, and nothing
    // to a test — which is part of how the denominator came to be wrong
    // (`totalSteps` was the RAW track length) without anything noticing.
    <div
      data-testid="tutorial-progress-bar"
      role="progressbar"
      aria-label="Walkthrough progress"
      aria-valuemin={1}
      aria-valuenow={Math.min(currentStep + 1, totalSteps)}
      aria-valuemax={totalSteps}
      className="fixed top-16 left-0 right-0 h-[3px] bg-muted z-[9998]"
    >
      <div
        className="h-full bg-primary transition-all duration-300 ease-out"
        style={{ width: `${progress}%` }}
      />
    </div>
  );
};
